export function changeDisable(option){
  if (option === 'v') {
    return true;
  } else {
    return false;
  }
}

export function showLabelItem(lista = [], item = null) {
  
}